module.exports = __webpack_public_path__ + "static/gallery18-05e1c7907a8da666d38ebc01c0bf379d.jpg";